import {Platform, Text, View, ViewStyle} from 'react-native';
import React from 'react';
import {LessonStatus} from 'stores/ClassStore';
import ViewAnalyticsButtonForWeb from '../../atoms/viewAnalyticsButtonForWeb';
import {useTheme} from 'contexts/ThemeContext';
import strings from '../../../translations';
import LessonStatuses from 'components/atoms/lessonStatuses';
import GetRecordingButton from 'components/atoms/getRecordingButton';
import styleSheet from './styles';

export interface AnalyticsLessonCellProps {
  index: number;
  status: LessonStatus;
  subject: string;
  group: string;
  time: string;
  onPress(): void;
  onGetRecordingButtonPressed?(): void;
  isRecordingNeeded?: boolean;
  isRecordingRequest?: boolean;
}

const AnalyticsLessonCell = (props: AnalyticsLessonCellProps) => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();

  const LeftPart = (
    <View style={styles.flexStart}>
      <View style={styles.flexStart}>
        <Text style={styles.headerTextStyle}>
          {strings.analyticsScreen.subject}
        </Text>
        <Text style={styles.cellTextStyle}>{props.subject}</Text>
      </View>

      <View style={styles.flexStart}>
        <Text style={styles.headerTextStyle}>
          {strings.analyticsScreen.time}
        </Text>
        <Text style={styles.cellTextStyle}>{props.time}</Text>
      </View>

      <View style={styles.flexStart}>
        <Text style={styles.headerTextStyle}>
          {strings.createClassScreen.group}
        </Text>
        <Text style={styles.cellTextStyle}>{props.group}</Text>
      </View>

      <View style={styles.flexStart}>
        {props.status === LessonStatus.completed && (
          <ViewAnalyticsButtonForWeb onPress={() => props.onPress()} />
        )}
      </View>
    </View>
  );

  const RightPart = (
    <View>
      <LessonStatuses status={props.status} />
    </View>
  );

  const MobileView = (
    <View style={styles.container as ViewStyle}>
      <View style={[styles.defaultCellStyle, styles.cellStyle]}>
        {LeftPart}
        {RightPart}
      </View>
    </View>
  );

  const WebView = (
    <View style={[styles.defaultCellStyle, styles.cellStyleWeb(props.index)]}>
      <View style={styles.flexStart}>
        <Text style={styles.cellTextStyleWeb}>{props.subject}</Text>
      </View>

      <View style={styles.flexStart}>
        <Text
          style={
            styles.cellTextStyleWeb
          }>{`${strings.createClassScreen.group} ${props.group}`}</Text>
      </View>

      <View style={styles.flexStart}>
        <LessonStatuses status={props.status} />
      </View>

      {props.status === LessonStatus.completed ? (
        <View style={[styles.defaultCellStyle, styles.flexStartForButtons]}>
          <>
            <ViewAnalyticsButtonForWeb onPress={() => props.onPress()} />

            {!props.isRecordingNeeded && !props.isRecordingRequest && (
              <GetRecordingButton
                onGetRecordingButtonPressed={() =>
                  props.onGetRecordingButtonPressed?.()
                }
                buttonStyle={styles.getRecordingButtonStyle}
                textButtonStyle={styles.getRecordingTextButtonStyle}
              />
            )}
          </>
        </View>
      ) : (
        <View style={[styles.defaultCellStyle, styles.flexStartForButtons]} />
      )}
    </View>
  );

  const Cell = <View>{Platform.OS !== 'web' ? MobileView : WebView}</View>;

  return Cell;
};

export default AnalyticsLessonCell;
